import { createSelector } from 'reselect';
import { NAME, type WorkbenchSlice, type WorkbenchState } from './slice.js';

export const getState = (state: WorkbenchSlice): WorkbenchState => state[NAME];

export const getLastScratchSave = createSelector(getState, (state) => state.lastScratchSave);

export const getExpandPanelRequest = createSelector(getState, (state) => state.expandPanelRequest);

export const getSetupApiIndexingOpen = createSelector(getState, (state) => state.setupApiIndexingOpen);
